(() => {
  const ICON_SEARCH =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/></svg>';
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const init = (root) => {
    if (!root || root.dataset.nvReady) return;
    root.dataset.nvReady = '1';

    const desktop = window.matchMedia('(min-width: 990px)');

    /* ---------- Desktop dropdowns ---------- */
    const items = [...root.querySelectorAll('[data-nv-navitem]')];
    let closeTimer;

    const place = (dd) => {
      dd.style.setProperty('--nv-shift', '0px');
      const r = dd.getBoundingClientRect();
      const m = 16;
      let shift = 0;
      if (r.left < m) shift = m - r.left;
      else if (r.right > window.innerWidth - m) shift = window.innerWidth - m - r.right;
      if (shift) dd.style.setProperty('--nv-shift', `${Math.round(shift)}px`);
    };
    const setOpen = (item, open) => {
      const btn = item.querySelector('[data-nv-nav-toggle]');
      const dd = item.querySelector('[data-nv-dropdown]');
      if (!btn || !dd) return;
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      dd.hidden = !open;
      if (open) place(dd);
    };
    const closeAll = (except) => items.forEach((it) => it !== except && setOpen(it, false));

    items.forEach((item) => {
      const btn = item.querySelector('[data-nv-nav-toggle]');
      btn.addEventListener('click', () => {
        const open = !item.classList.contains('is-open');
        closeAll(item);
        setOpen(item, open);
      });
      item.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        closeTimer = setTimeout(() => setOpen(item, false), 150);
      });
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
    });

    /* ---------- Search bar + suggestions ---------- */
    const search = root.querySelector('[data-nv-search]');
    const input = root.querySelector('[data-nv-search-input]');
    const panel = root.querySelector('[data-nv-search-panel]');
    const toggles = [...root.querySelectorAll('[data-nv-search-toggle]')];
    const suggestUrl = root.dataset.nvSuggestUrl || '/search/suggest';
    let ctrl;
    let timer;

    const hidePanel = () => {
      if (panel) panel.hidden = true;
    };
    const setSearch = (open) => {
      if (!search) return;
      search.classList.toggle('is-open', open);
      search.toggleAttribute('inert', !open);
      toggles.forEach((t) => t.setAttribute('aria-expanded', open ? 'true' : 'false'));
      if (open) setTimeout(() => input && input.focus({ preventScroll: true }), 60);
      else hidePanel();
    };
    toggles.forEach((t) => t.addEventListener('click', () => setSearch(!search.classList.contains('is-open'))));

    const money = (value) => {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(Number(value));
      } catch (e) {
        return value;
      }
    };
    const highlight = (text, q) => {
      const i = text.toLowerCase().indexOf(q.toLowerCase());
      if (i < 0) return esc(text);
      return `${esc(text.slice(0, i))}<b>${esc(text.slice(i, i + q.length))}</b>${esc(text.slice(i + q.length))}`;
    };
    const paint = (q, res) => {
      const queries = res.queries || [];
      const products = res.products || [];
      let html = '';
      if (queries.length) {
        html += '<div class="nv-h-search-sec"><div class="nv-h-search-sec__title">Suggestions</div>';
        html += queries
          .map((s) => `<a class="nv-h-search-term" href="${esc(s.url)}">${ICON_SEARCH}<span>${highlight(s.text, q)}</span></a>`)
          .join('');
        html += '</div>';
      }
      if (products.length) {
        html += '<div class="nv-h-search-sec"><div class="nv-h-search-sec__title">Products</div>';
        html += products
          .map((p) => {
            const src = p.featured_image && p.featured_image.url;
            const img = src
              ? `<img src="${esc(src)}${src.includes('?') ? '&' : '?'}width=96" alt="" width="44" height="44" loading="lazy">`
              : '';
            return `<a class="nv-h-search-prod" href="${esc(p.url)}"><span class="nv-h-search-prod__img">${img}</span><span class="nv-h-search-prod__t"><span class="nv-h-search-prod__title">${esc(p.title)}</span><span class="nv-h-search-prod__meta">${esc(money(p.price))}</span></span></a>`;
          })
          .join('');
        html += '</div>';
      }
      if (!html) html = `<div class="nv-h-search-empty">No results for “${esc(q)}”</div>`;
      panel.innerHTML = html;
      panel.hidden = false;
    };
    const suggest = async (q) => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url = `${suggestUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last`;
      try {
        const res = await fetch(url, { signal: ctrl.signal });
        if (!res.ok) return;
        const data = await res.json();
        if (input.value.trim() === q) paint(q, data.resources.results);
      } catch (e) {
        /* aborted or offline: keep the plain form working */
      }
    };
    if (input && panel) {
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (q.length < 2) return hidePanel();
        timer = setTimeout(() => suggest(q), 200);
      });
    }

    /* ---------- Mobile drawer ---------- */
    const drawer = root.querySelector('[data-nv-drawer]');
    const backdrop = root.querySelector('[data-nv-backdrop]');
    const menuBtn = root.querySelector('[data-nv-menu-open]');
    const panels = drawer ? new Map([...drawer.querySelectorAll('[data-nv-panel]')].map((p) => [p.dataset.nvPanel, p])) : new Map();
    const navbar = drawer && drawer.querySelector('[data-nv-drawer-navbar]');
    const title = drawer && drawer.querySelector('[data-nv-drawer-title]');
    const back = drawer && drawer.querySelector('[data-nv-back]');
    let stack = ['root'];

    const renderPanels = () => {
      const current = stack[stack.length - 1];
      panels.forEach((p, id) => {
        p.classList.toggle('is-active', id === current);
        p.classList.toggle('is-prev', id !== current && stack.includes(id));
      });
      navbar.hidden = stack.length < 2;
      back.classList.toggle('is-hidden', stack.length < 2);
      title.textContent = (panels.get(current) && panels.get(current).dataset.nvTitle) || '';
    };
    const openDrawer = () => {
      if (!drawer) return;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      const close = drawer.querySelector('[data-nv-menu-close]');
      if (close) close.focus({ preventScroll: true });
    };
    const closeDrawer = () => {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(() => {
        stack = ['root'];
        renderPanels();
      }, 300);
    };

    if (drawer) {
      menuBtn.addEventListener('click', openDrawer);
      backdrop.addEventListener('click', closeDrawer);
      drawer.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-nv-panel-open]');
        if (opener && panels.has(opener.dataset.nvPanelOpen)) {
          stack.push(opener.dataset.nvPanelOpen);
          renderPanels();
        } else if (e.target.closest('[data-nv-back]') && stack.length > 1) {
          stack.pop();
          renderPanels();
        } else if (e.target.closest('[data-nv-menu-close]')) {
          closeDrawer();
        }
      });
      desktop.addEventListener('change', (e) => e.matches && closeDrawer());
    }

    /* Keep the drawer's "Cart (n)" in sync when the theme re-renders #cart-icon-bubble */
    const bubble = root.querySelector('#cart-icon-bubble');
    const drawerCount = root.querySelector('[data-nv-drawer-count]');
    if (bubble && drawerCount && 'MutationObserver' in window) {
      new MutationObserver(() => {
        const count = bubble.querySelector('.nv-h__cart-count');
        drawerCount.textContent = count && !count.hidden ? count.textContent.trim() : '0';
      }).observe(bubble, { childList: true, subtree: true });
    }

    /* ---------- Global closers ---------- */
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) {
        closeAll();
        hidePanel();
      } else if (panel && !panel.contains(e.target) && !(search && search.contains(e.target))) {
        hidePanel();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeAll();
      closeDrawer();
      if (search && search.classList.contains('is-open')) setSearch(false);
    });

    /* Theme editor: open the collections dropdown while its block is selected */
    root.addEventListener('shopify:block:select', (e) => {
      const item = e.target.closest('[data-nv-navitem]');
      if (item && desktop.matches) {
        closeAll(item);
        setOpen(item, true);
      }
    });
    root.addEventListener('shopify:block:deselect', () => closeAll());
  };

  const boot = () => document.querySelectorAll('[data-nv-header]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-nv-header]')));
})();
